import React from 'react'

function Checkbox(props) {
  const {
    checked,
    id,
    onClick
  } = props

  return (
    <div className='custom-control custom-checkbox mb-1'>
      <input id={ id } className='custom-control-input' type='checkbox' defaultChecked={ checked } onClick={ onClick }/>
      <label className='custom-control-label' htmlFor={ id }>
        { props.children }
      </label>
    </div>
  )
}

export default Checkbox
